import React, { Component } from 'react'
import { compose, graphql, withApollo } from 'react-apollo'
import { GetUnfinishedCompositionsCount } from '@sukiai/gql/app'
import { HamburgerMenu, Constants } from '@sukiai/components'
import {
  ROUTES,
  LO_STO,
  logout,
  HALF_STORY,
  printCurrentNote,
  emailCurrentNote,
  FETCH_POLICY,
  showScripts,
  showNotetypes,
  inScheduleView,
  inPatientView,
  showSettings
} from '../lib'
import { getStreamWorker } from '../ws/stream'
import { withRouter } from 'react-router'
import loSto from '../config/loSto'
import {
  GET_NOTES_LIST,
  SET_AGENT_POSITION,
  SET_AGENT_SIZE,
  SET_MODAL,
  GET_MODAL,
  CLEAR_MODAL,
  GET_CURRENT_NOTETYPE_ID,
  SET_NOTE_PULL_RESPONSE
} from '../apollo/actions'
import { halfStory as hs } from '../lib/logging'
import get from 'lodash/get'

const { MODALS, AGENT } = Constants

class HamburgerMenuContainer extends Component {
  state = {
    watchIds: [],
    noteId: loSto.get(LO_STO.CURRENT_NOTE_ID),
    patientId: loSto.get(LO_STO.CURRENT_PATIENT_ID)
  }

  componentDidMount () {
    const watchIds = []
    watchIds.push(loSto.watch(LO_STO.CURRENT_NOTE_ID, id => this.updateId('noteId', id)))
    watchIds.push(loSto.watch(LO_STO.CURRENT_PATIENT_ID, id => this.updateId('patientId', id)))
  }

  updateId = (name, id) => this.setState({ [name]: id })

  componentWillUnmount () {
    this.state.watchIds.forEach(wId => loSto.unwatch(wId))
  }

  recordToggle = open => {
    hs.add(HALF_STORY.CLICK, `${open ? 'Opening' : 'Closing'} hamburger menu`)
  }

  toRoute = route => {
    const { history, clearModal } = this.props

    hs.add(HALF_STORY.CLICK, `Going to ${route} from hamburger menu`)
    // also save half story (on route changes)
    hs.save()

    clearModal()
    history.push(route)
  }

  deleteCurrentNote = () => {
    const {
      setModal,
      setAgentPosition,
      setAgentSize
    } = this.props

    setAgentPosition(AGENT.POSITION.TOP_LEFT)
    setAgentSize(AGENT.SIZE.SMALL)
    setModal({
      __typename: 'ModalContent',
      type: MODALS.DELETE_NOTE,
      heading: 'Delete note?',
      body: 'Please confirm.'
    })
  }

  printNotesModal = () => {
    const {
      setModal,
      setAgentPosition,
      setAgentSize
    } = this.props

    const modalHeading = 'Print or Save notes?'
    let modalBody = 'This will print or save all notes.'
    if (inPatientView()) {
      try {
        const user = loSto.get(LO_STO.CURRENT_USER)
        modalBody = `Print or save all of ${user.person.firstName} ${user.person.lastName}'s notes.`
      } catch (err) {
        console.error('User does not have first and last name :(')
        modalBody = 'This will print or save all of the patient\'s prior notes.'
      }
    } else if (inScheduleView()) {
      modalBody = 'This will print or save all of the notes for appointments on this date.'
    }

    setAgentPosition(AGENT.POSITION.TOP_LEFT)
    setAgentSize(AGENT.SIZE.SMALL)
    setModal({
      __typename: 'ModalContent',
      type: MODALS.PRINT_NOTES,
      heading: modalHeading,
      body: modalBody
    })
  }

  onRefreshNoteFromEmr = async () => {
    const { client, setModal } = this.props

    // works because button is only available on note view
    const compId = location.pathname.split('/')[2]
    const ntRes = await client.query({
      query: GET_CURRENT_NOTETYPE_ID
    })
    const currentNotetypeId = ntRes?.data?.currentNotetypeId
    const patientId = loSto.get(LO_STO.CURRENT_PATIENT_ID)
    const appointmentId = loSto.get(LO_STO.CURRENT_APPT_ID)

    const stream = getStreamWorker()
    stream && stream.postMessage({
      cmd: 'USER_REQUEST',
      userRequestType: 'CLICK_NOTES_PULL',
      userRequestData: {
        compositionId: compId,
        notetypeId: currentNotetypeId,
        patientId: patientId,
        appointmentId: appointmentId
      },
      ts: new Date().toISOString()
    })

    setModal({
      __typename: 'ModalContent',
      type: MODALS.EMR_NOTE_PULL
    })

    client.mutate({
      mutation: SET_NOTE_PULL_RESPONSE,
      variables: {
        isPending: true
      }
    })
  }

  onLogout = () => {
    hs.add(HALF_STORY.LOGOUT, 'Logging out due to user menu button')
    // Save on logout
    hs.save()
    logout()
  }

  render () {
    const { inReadOnlyNote, unfinishedCount, compositionsList, patientNotesList, marginTop } = this.props
    const { noteId, patientId } = this.state
    // start using a utility function for things like this
    const inNoteView = window.location.pathname.split('/')[1] === 'note'

    return (
      <HamburgerMenu
        noteCount={unfinishedCount}
        currentUser={loSto.get(LO_STO.CURRENT_USER)}
        toHelp={() => this.toRoute(ROUTES.HELP)}
        toHome={() => this.toRoute(ROUTES.HOME)}
        toSchedule={() => this.toRoute(ROUTES.SCHEDULE)}
        toSettings={showSettings}
        toUnfinishedNotes={() => this.toRoute(ROUTES.UNFINISHED_NOTES)}
        printNoteEnabled={inNoteView || noteId}
        showBulkPrint={!inReadOnlyNote && (inScheduleView() || inPatientView())}
        printNotesEnabled={(compositionsList && compositionsList.length > 0) || (patientNotesList && patientNotesList.length > 0)}
        printNote={printCurrentNote}
        emailNote={emailCurrentNote}
        printNotesModal={this.printNotesModal}
        deleteNoteEnabled={inNoteView}
        deleteCurrentNote={this.deleteCurrentNote}
        patientNotesEnabled={patientId}
        toPatientNotes={() => this.toRoute(`${ROUTES.PATIENT_NOTES}/${patientId}`)}
        showScripts={showScripts}
        logout={this.onLogout}
        recordToggle={this.recordToggle}
        showNotetypes={showNotetypes}
        marginTop={marginTop}
      />
    )
  }
}

const mapUnfinishedToProps = ({ data }) => ({
  unfinishedError: data.error,
  unfinishedLoading: data.loading,
  unfinishedCount: data.incompleteCompositions ? data.incompleteCompositions.count : 0
})

const mapNotesListToProps = ({ data: { notesList } }) => ({
  compositionsList: notesList && notesList.compositionIds,
  patientNotesList: notesList && notesList.patientNoteIds
})

const mapModalToProps = ({ data }) => {
  const type = get(data, 'modal.content.type', '')
  return { inReadOnlyNote: type === MODALS.READ_NOTE }
}

export default compose(
  graphql(GET_MODAL, { props: mapModalToProps }),
  graphql(CLEAR_MODAL, { name: 'clearModal' }),
  graphql(GET_NOTES_LIST, { props: mapNotesListToProps }),
  graphql(SET_AGENT_POSITION, {
    props: ({ mutate }) => ({
      setAgentPosition: agentPosition => mutate({
        variables: { agentPosition }
      })
    })
  }),
  graphql(SET_AGENT_SIZE, {
    props: ({ mutate }) => ({
      setAgentSize: agentSize => mutate({
        variables: { agentSize }
      })
    })
  }),
  graphql(SET_MODAL, {
    props: ({ mutate }) => ({
      setModal: content => mutate({
        variables: { content }
      })
    })
  }),
  graphql(GetUnfinishedCompositionsCount, {
    skip: () => !loSto.get(LO_STO.USER_ID),
    options: () => ({
      variables: {
        userId: loSto.get(LO_STO.USER_ID)
      },
      fetchPolicy: FETCH_POLICY.NETWORK_ONLY
    }),
    props: mapUnfinishedToProps
  }),
  withRouter,
  withApollo
)(HamburgerMenuContainer)
